const EGDSLinkThemeMap = [['default', 'default'], ['inverse', 'inverse']];
const EGDSLinkThemes = new Map(EGDSLinkThemeMap);
const EGDSLinkSizeMap = [['small', 'small'], ['medium', 'medium'], ['large', 'large']];
const EGDSLinkSizes = new Map(EGDSLinkSizeMap);
const EGDSLinkAlignMap = [['left', 'left'], ['center', 'center'], ['right', 'right']];
const EGDSLinkAligns = new Map(EGDSLinkAlignMap);
export { EGDSLinkAligns, EGDSLinkSizes, EGDSLinkThemes };